import { useCallback, useEffect, useState } from 'react';
import { getAnalyticsConsent, setAnalyticsConsent } from '../../../lib/analyticsConsent';
import { useMixpanel } from '../../../lib/mixpanel';

export function useAnalyticsConsent() {
  const mp = useMixpanel();
  const [enabled, setEnabled] = useState(true);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void getAnalyticsConsent().then((granted) => {
      if (!cancelled) {
        setEnabled(granted);
        setIsReady(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const setConsent = useCallback(
    async (next: boolean) => {
      setEnabled(next);
      await setAnalyticsConsent(next);
      if (next) {
        mp.optInTracking();
      } else {
        mp.optOutTracking();
      }
    },
    [mp],
  );

  return { enabled, isReady, setConsent };
}
